// extracted by mini-css-extract-plugin
export default {"sparkline":"sparkline_sparkline__76zOM"};